import React from 'react';

import { useDesignVersion } from '../../context/useDesignVersion';

const V2LegacyReturnButton: React.FC = () => {
  const { setDesignVersion } = useDesignVersion();

  const handleReturnToLegacy = () => {
    setDesignVersion('legacy');
  };

  return (
    <button type="button" className="workspace-footer__legacy-link" onClick={handleReturnToLegacy}>
      Предыдущая версия <span aria-hidden="true">↗</span>
    </button>
  );
};

export default V2LegacyReturnButton;
